export default "__VITE_ASSET__eccb0e88__"